import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Last line of defense: a render crash anywhere in the tree shows a branded
// recovery screen instead of a blank page. Data-fetch errors are handled
// per-page; this only catches unrecoverable render errors.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('App crashed:', error, info?.componentStack);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: '100vh', background: '#050507', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '2rem', fontFamily: "system-ui, -apple-system, sans-serif" }}>
          <div style={{ fontSize: '1.6rem', fontWeight: 900, letterSpacing: '0.06em', color: '#fff' }}>SNUTZY</div>
          <div style={{ marginTop: '0.3rem', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.5em', textIndent: '0.5em', color: '#a78bfa' }}>&times; SHUFFLE</div>
          <p style={{ color: '#a1a1aa', fontSize: '0.95rem', margin: '1.5rem 0', maxWidth: '380px', lineHeight: 1.6 }}>
            Something broke on our end. Reload to pick up where you left off — your rewards and progress are safe on the server.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{ padding: '0.75rem 1.75rem', background: 'linear-gradient(135deg, #a855f7, #7c3aed)', border: 'none', borderRadius: '10px', color: '#fff', fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer' }}
          >
            Reload the site
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
